import { Box, Link, Typography } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import EmailIcon from "@mui/icons-material/Email";

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#0a0a0a",
        padding: { xs: "40px 24px", md: "60px 80px" },
        color: "#fff",
      }}
    >
      {/* Main footer content */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          flexWrap: "wrap",
          gap: "40px",
        }}
      >
        {/* Left side — Logo, Social Icons, Copyright */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          {/* Logo */}
          <Typography
            sx={{
              fontFamily: "'Courier New', monospace",
              fontSize: "22px",
              fontWeight: 700,
              color: "#00d4d4",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {/* Replace this span with your actual logo/icon component */}
            <span style={{ fontSize: "28px" }}>꩜</span>
            OmMuse
          </Typography>

          {/* Social Icons */}
          <Box sx={{ display: "flex", gap: "16px" }}>
            <Link
              target="_blank"
              href="https://www.instagram.com/ommuse.music/"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <InstagramIcon sx={{ fontSize: 22 }} />
            </Link>
            <Link
              target="_blank"
              href="https://www.facebook.com/ommuse.music"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <FacebookIcon sx={{ fontSize: 22 }} />
            </Link>
            <Link
              target="_blank"
              href="https://www.youtube.com/@ommuse"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <YouTubeIcon sx={{ fontSize: 22 }} />
            </Link>
            <Link
              href="mailto:hello@ommuse.com"
              sx={{ color: "#fff", "&:hover": { color: "#00d4d4" } }}
            >
              <EmailIcon sx={{ fontSize: 22 }} />
            </Link>
          </Box>

          {/* Copyright */}
          <Typography
            sx={{
              fontSize: "13px",
              color: "#888",
              marginTop: "8px",
            }}
          >
            © 2026. All Rights Reserved
          </Typography>
        </Box>

        {/* Right side — Two columns of nav links */}
        <Box sx={{ display: "flex", gap: { xs: "48px", md: "80px" } }}>
          {/* Column 1 */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {["Features", "Explore", "Pricing", "Enterprise"].map((label) => (
              <Link
                key={label}
                href={`/${label.toLowerCase()}`}
                underline="none"
                sx={{
                  color: "#ccc",
                  fontSize: "14px",
                  transition: "color 0.2s",
                  "&:hover": { color: "#00d4d4" },
                }}
              >
                {label}
              </Link>
            ))}
          </Box>

          {/* Column 2 */}
          <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
            {[
              { label: "Enterprise Addendum", href: "/enterprise-addendum" },
              { label: "Privacy", href: "/privacy-policy" },
              { label: "Terms", href: "/terms-of-use" },
              { label: "Accessibility", href: "/accessibility" },
            ].map(({ label, href }) => (
              <Link
                key={label}
                href={href}
                underline="none"
                sx={{
                  color: "#ccc",
                  fontSize: "14px",
                  transition: "color 0.2s",
                  "&:hover": { color: "#00d4d4" },
                }}
              >
                {label}
              </Link>
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;